import React, { useRef, useState } from "react";
import SubHeader from "../customComponents/SubHeader";
import { Autocomplete, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { showAlert } from "../../redux/alertSlice";
import api from "../../utils/axiosInstance";
import moment from "moment";
import CombinedGroupedStockReportTable from "../customComponents/tables/CombinedGroupedStockReportTable";

const tableConfig = [
  {
    key: "itemName",
    label: "Item Name",
    width: "30%",
    align: "left",
    dataKey: "itemName",
  },
  {
    key: "headName",
    label: "Head Name",
    width: "30%",
    align: "left",
    dataKey: "headName",
  },
  {
    key: "abuplaza",
    label: "ABUPLAZA",
    width: "13%",
    align: "right",
    dataKey: "abuplaza",
  },
  {
    key: "shastriNa",
    label: "SHASTRI NA",
    width: "13%",
    align: "right",
    dataKey: "shastriNa",
  },
    {
    key: "meerutCt",
    label: "Meerut Ct",
    width: "14%",
    align: "right",
    dataKey: "meerutCt",
  },
];
const dummyReportData = {
  tableData: [
    {
      itemName: "Gold Necklace",
      headName: "Jewellery",
      abuplaza: 7,
      shastriNa: 4,
      meerutCt: 9,
    },
    {
      itemName: "Diamond Ring",
      headName: "Jewellery",
      abuplaza: 3,
      shastriNa: 8,
      meerutCt: 6,
    },
    {
      itemName: "Silver Anklet",
      headName: "Accessories",
      abuplaza: 9,
      shastriNa: 2,
      meerutCt: 7,
    },
    {
      itemName: "Gold Bangles",
      headName: "Jewellery",
      abuplaza: 5,
      shastriNa: 6,
      meerutCt: 10,
    },
    {
      itemName: "Platinum Chain",
      headName: "Premium",
      abuplaza: 8,
      shastriNa: 3,
      meerutCt: 4,
    },
    {
      itemName: "Silver Coin",
      headName: "Gifts",
      abuplaza: 2,
      shastriNa: 9,
      meerutCt: 5,
    },
    {
      itemName: "Gold Pendant",
      headName: "Jewellery",
      abuplaza: 6,
      shastriNa: 7,
      meerutCt: 3,
    },
    {
      itemName: "Diamond Bracelet",
      headName: "Premium",
      abuplaza: 4,
      shastriNa: 5,
      meerutCt: 8,
    },
    {
      itemName: "Silver Ring",
      headName: "Accessories",
      abuplaza: 10,
      shastriNa: 1,
      meerutCt: 2,
    },
    {
      itemName: "Gold Chain",
      headName: "Jewellery",
      abuplaza: 1,
      shastriNa: 10,
      meerutCt: 6,
    },
    {
      itemName: "Diamond Pendant",
      headName: "Premium",
      abuplaza: 9,
      shastriNa: 4,
      meerutCt: 5,
    },
  ],

  totals: {
    abuplaza: 54,
    shastriNa: 59,
    meerutCt: 65,
  },
};


const CombinedGroupedStockReport = ({ toggleMobileMenu }) => {
  const [selectedValue, setSelectedValue] = useState(null);
  const [data, setData] = useState([]);

  const [inputValue, setInputValue] = useState("");
  const [reportData, setReportData] = useState(dummyReportData); // option array coming from searching

  const searchBoxRef = useRef();
  const debounceTimeout = useRef(null); // Ref to store the timeout

  // Updated formData with new filters
  const [formData, setFormData] = useState({
    asOnDate: moment(new Date()).format("YYYY-MM-DD"),
    type: "", // "G" or "D"
    branch: "", // Branch Name
  });

  const [statement, setStatement] = useState([]);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  // Example getCustomerList API (for customer autocomplete search)
  const getCustomerList = async (value) => {
    try {
      const response = await api.get(
        `/customers/get-all-customers?search=${value}`
      );
      if (response.status === 200) {
        const list = response.data;
      }
    } catch (error) {
      console.log("Error while loading customers " + error);
    }
  };

  const getCustomerData = async () => {
    try {
      setLoading(true);
      // Send API request with the three filters
      const response = await api.post("/stocks/get-grouped-stock", {
        asOnDate: formData.asOnDate,
        type: formData.type,
        branch: formData.branch,
      });

      if (response.data?.success) {
        setStatement(response.data.data);
      } else {
        setStatement([]);
        dispatch(
          showAlert({
            message: response.data.message || "No data found",
            severity: "warning",
          })
        );
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      dispatch(
        showAlert({ message: "Error fetching data", severity: "error" })
      );
    }
  };

  const handleSearch = (e) => {
    const { value } = e.target;
    if (value && value !== "") {
      setInputValue(value);

      // Debouncing logic
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      debounceTimeout.current = setTimeout(() => {
        getCustomerList(value);
      }, 1000); // 1-second delay
    }
  };

  //   // Optional helper function to reset filters if you want to add that later
  //   const handleClearForm = () => {
  //     setFormData({
  //       asOnDate: moment(new Date()).format("YYYY-MM-DD"),
  //       type: "",
  //       branch: "",
  //     });
  //     setStatement([]);
  //     setSelectedValue(null);
  //     setInputValue("");
  //   };

  return (
    <>
      <SubHeader
        text={"Combined Grouped Stock Report"}
        toggleMobileMenu={toggleMobileMenu}
      />
      <div className="w-full max-w-[1100px] mx-auto px-4 lg:px-0">
        <div className="relative w-full lg:min-h-[550px] rounded-[10px] mt-8 mb-2 shadow-custom-dark">
          <div className="w-full py-4 lg:pt-6 px-4 lg:px-8">
            <div>
              <div className="font-mont font-semibold pb-2">
                Filters
              </div>

              <div className="flex flex-col lg:flex-row px-0 lg:px-2 gap-4 lg:gap-6 lg:items-end mt-4 lg:mt-0">
                {/* As on Date */}
                <TextField
                  sx={{ width: { xs: "100%", lg: "30%" } }}
                  value={formData.asOnDate}
                  label="As on Date"
                  variant="standard"
                  type="date"
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      asOnDate: e.target.value,
                    }))
                  }
                />

                {/* Type (G/D) */}
                <TextField
                  select
                  label="Type"
                  variant="standard"
                  SelectProps={{ native: true }}
                  sx={{ width: { xs: "100%", lg: "20%" } }}
                  value={formData.type}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, type: e.target.value }))
                  }
                >
                  <option value=""></option>
                  <option value="G">G</option>
                  <option value="D">D</option>
                </TextField>

                {/* Available / SHortage */}
                <span className="w-[200px]">Available/Shortage (A/S) :</span>
                <div className="flex justify-start mt-6">
                  <button
                    className="w-full lg:w-auto py-2 px-10 border bg-sixth text-white text-sm font-mont font-semibold rounded-[5px] hover:bg-sixth/80"
                    disabled={loading}
                    onClick={getCustomerData}
                  >
                    {loading ? "Loading..." : "Get Data"}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full px-4 lg:px-7 pb-6">
            <CombinedGroupedStockReportTable
              tableData={reportData ? reportData.tableData : []}
              totals={reportData ? reportData.totals : {}}
              loading={false}
              columns={tableConfig}
              searchFields={["itemName", "headName"]}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CombinedGroupedStockReport;
